import React from 'react';
import PropTypes from 'prop-types';

import {
    Text,
} from '@zillow/constellation';

// Utils
import propertyUtils from 'app/shared/utils/propertyUtils';

import { StyledSpacer, StyledText } from './StyledComponents';

const propTypes = {
    index: PropTypes.number.isRequired,
    onClick: PropTypes.func,
    listingKey: PropTypes.string.isRequired,
    listing: PropTypes.object.isRequired,
    useAddress: PropTypes.bool,
};

const defaultProps = {
    onClick: undefined,
    useAddress: false,
};

const AddressColumn = ({
    index,
    onClick,
    listingKey,
    listing,
    useAddress,
}) => {
    const handleClick = (event) => {
        event.preventDefault();
        if (onClick) {
            onClick(listingKey);
        }
    };
    if (!listing) {
        return `Property #${index}`;
    }
    const { formattedName, formattedStreet, formattedCityState } = propertyUtils.formatAddress(listing);

    return (
        <StyledSpacer paddingRight="sm" onClick={handleClick} isClickable={onClick !== undefined}>
            <StyledText as="div" fontType="finePrint">
                {useAddress ? formattedStreet : formattedName || formattedStreet}
            </StyledText>
            <Text as="div" fontType="finePrint">
                {formattedCityState}
            </Text>
        </StyledSpacer>
    );
};

AddressColumn.propTypes = propTypes;
AddressColumn.defaultProps = defaultProps;

export default AddressColumn;
